import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import type { UseMutationOptions, UseMutationResult } from 'react-query';

const baseEndpoint = 'ums/v1/cms/bnpl/credit-facilities';

interface BodyType {
  amount: number;
  notes?: string;
}

type TData = Record<string, any>;
type TError = AxiosError;
type TVariables = { facilityId: number; body: BodyType };
type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useCreateFacilityRepaymentApi(options?: Options): ReturnType {
  const toast = useCustomToast();

  const mutationFn = async ({ facilityId, body }: TVariables) => {
    try {
      const { data } = await http.post(`${baseEndpoint}/${facilityId}/repayment`, body);
      return data;
    } catch (error: any) {
      if (!error.response?.status || !error.response?.data?.message) throw error;
      toast({ description: error.response.data.message, status: 'error' });
      throw error;
    }
  };

  return useMutationWrapper(mutationFn, {
    ...options,
    mutationKey: [`${baseEndpoint}/repayment`],
    onSuccess: () => {
      toast({ description: 'Repayment recorded successfully', status: 'success' });
    },
  });
}
